import ApiBase from './ApiBase'
import {Feedback} from '../model/models'
import ApiResponse from '../model/ApiResponse'

export default class FeedbackApi extends ApiBase {
  async submit(feedback: string) {
    return await this.post('feedback/submit', {feedback})
  }
  
  async getAll(): Promise<ApiResponse<Feedback[] | null>> {
    return await this.get<Feedback[]>('feedback/all')
  }
}
